import { render, staticRenderFns } from "./PanelTable.vue?vue&type=template&id=4c182eba&scoped=true&"
import script from "./PanelTable.vue?vue&type=script&lang=js&"
export * from "./PanelTable.vue?vue&type=script&lang=js&"
import style0 from "./PanelTable.vue?vue&type=style&index=0&id=4c182eba&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c182eba",
  null
  
)

export default component.exports